'use client';

import { FC, HTMLAttributes } from 'react';

import { useTabsContext } from '../dynamo-tabs/tabs.context';

export interface TabContentProps extends HTMLAttributes<HTMLDivElement> {
  id: string;
}

export const TabContent: FC<TabContentProps> = ({ id, children, ...props }) => {
  const context = useTabsContext();
  const isActive = id && context ? context.activeTabId === id : false;

  return (
    <div role='tabpanel' hidden={!isActive} {...props} id={id}>
      {children}
    </div>
  );
};
